<template>
	<div v-loading="loading" v-if="show" style="width: 100%;height: 100%;">
		<div v-if="equipment == 'pc'" style="width: 100%;height: 100%;">
			<div>
				<div style="display: flex;align-items: center;justify-content: space-between;border-bottom: solid 1px #b3b3b3;flex-wrap: wrap;"
					v-if="footerData.services">
					<div style="display: flex;align-items: center;margin-bottom: 40px;"
						v-for="(item,index) in footerData.services.items" :key="index">
						<div><img
								:style="{width:(selectdItem.preStyle.font.size + 20) + 'px',height:(selectdItem.preStyle.font.size + 20) + 'px'}"
								:src="'http://shop910.com/' + item.image" /></div>
						<div style="margin-left: 10px;">
							<div>{{item.name}}</div>
							<div class="linktit" :style="{fontSize:(selectdItem.preStyle.font.size - 5) + 'px'}"
								style="color: #bababa ;margin-top: 4px;">{{item.sub_name}}</div>
						</div>
					</div>
				</div>
				<div style="margin-top: 50px;">
					<div style="display: flex;justify-content: space-between;flex-wrap: wrap;">
						<div>
							<img style="width: 280px;height: 120px;"
								:src="'http://shop910.com/' + footerData.content.intro.logo" />
							<div style="display: flex;align-items: center;margin-top: 10px;">
								<div @click.stop.prevent="headNavTo(item)"
									v-for="(item,index) in footerData.content.intro.social_network" :key="index">
									<img style="width: 30px;height: 30px;margin-left: 20px;"
										:src="'http://shop910.com/' + item.image" />
								</div>
							</div>
						</div>
						<div>
							<div style="font-weight: bold;"
								:style="{fontSize:(selectdItem.preStyle.font.size - 3) + 'px'}">
								{{footerData.content.link1.name}}
							</div>
							<div @click.stop.prevent="headNavTo(linkItem)"
								:style="{fontSize:(selectdItem.preStyle.font.size - 5) + 'px'}"
								style="color: #8f8f8f;cursor: pointer;margin-top: 12px;"
								v-for="(linkItem,linkIndex) in footerData.content.link1.links" :key="linkIndex">
								{{linkItem.text}}
							</div>
						</div>
						<div>
							<div style="font-weight: bold;"
								:style="{fontSize:(selectdItem.preStyle.font.size - 3) + 'px'}">
								{{footerData.content.link2.name}}
							</div>
							<div @click.stop.prevent="headNavTo(linkItem)"
								:style="{fontSize:(selectdItem.preStyle.font.size - 5) + 'px'}"
								style="color: #8f8f8f;cursor: pointer;margin-top: 12px;"
								v-for="(linkItem,linkIndex) in footerData.content.link2.links" :key="linkIndex">
								{{linkItem.text}}
							</div>
						</div>
						<div>
							<div style="font-weight: bold;"
								:style="{fontSize:(selectdItem.preStyle.font.size - 3) + 'px'}">
								{{footerData.content.link3.name}}
							</div>
							<div class="linktit" @click.stop.prevent="headNavTo(linkItem)"
								:style="{fontSize:(selectdItem.preStyle.font.size - 5) + 'px'}"
								style="color: #8f8f8f;cursor: pointer;margin-top: 12px;"
								v-for="(linkItem,linkIndex) in footerData.content.link3.links" :key="linkIndex">
								{{linkItem.text}}
							</div>
						</div>
					</div>
					<div>
					</div>
				</div>
			</div>
		</div>
		<div style="width: 100%;height: 100%;" v-if="equipment == 'phone'">
			<div
				style="display: flex;flex-wrap: wrap;align-items: center;justify-content: space-around;border-bottom: solid 1px #e1e1e1;padding-bottom: 30px;">
				<div style="display: flex;align-items: center;width: 48%;margin-top: 20px;"
					v-for="(item,index) in footerData.services.items" :key="index">
					<!-- <div><img :style="{width:(selectdItem.preStyle.font.size + 20) + 'px',height:(selectdItem.preStyle.font.size + 20) + 'px'}" :src="'http://shop910.com/' + item.image"/></div> -->
					<div style="margin-left: 10px;width: 100;">
						<div>{{item.name}}</div>
						<div :style="{fontSize:(selectdItem.preStyle.font.size - 5) + 'px'}"
							style="color: #bababa ;margin-top: 4px;width: 160px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;">
							{{item.sub_name}}
						</div>
					</div>
				</div>
			</div>
			<div :key="'link1-head'">
				<el-menu :unique-opened="true" background-color="#f5f5f5" style="border:solid 0px #e1e1e1;"
					class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
					<el-submenu :key="'link1'" :index="'link1'" :unique-opened="false"
						style="border-bottom:solid 1px #e1e1e1;">
						<template slot="title">
							<span style="color: #000000 ;" slot="title"
								:style="{fontSize:(selectdItem.preStyle.font.size - 4) + 'px'}">{{footerData.content.link1.name}}</span>
						</template>
						<el-menu-item class="linktit"
							:style="{fontSize:(selectdItem.preStyle.font.size - 6) + 'px','--hover': compontentStyle.hoverColor}"
							:key="linkIndex" :index="'link1' + '-' + linkIndex"
							v-for="(linkItem,linkIndex) in footerData.content.link1.links"
							@click.stop.prevent="headNavTo(linkItem)"
							style="font-size: 14px;color: #8f8f8f;cursor: pointer;">
							{{linkItem.text}}
						</el-menu-item>
					</el-submenu>
				</el-menu>
			</div>
			<div :key="'link2-head'">
				<el-menu background-color="#f5f5f5" style="border:solid 0px #e1e1e1;" class="el-menu-vertical-demo"
					@open="handleOpen" @close="handleClose">
					<el-submenu :key="'link2'" :index="'link2'" :unique-opened="false"
						style="border-bottom:solid 1px #e1e1e1;">
						<template slot="title">
							<span :style="{fontSize:(selectdItem.preStyle.font.size - 4) + 'px'}"
								style="color: #000000 ;" slot="title">{{footerData.content.link2.name}}</span>
						</template>
						<el-menu-item class="linktit" :key="linkIndex" :index="'link2' + '-' + linkIndex"
							v-for="(linkItem,linkIndex) in footerData.content.link2.links"
							@click.stop.prevent="headNavTo(linkItem)"
							style="color: #8f8f8f;cursor: pointer;margin-top: 12px;"
							:style="{fontSize:(selectdItem.preStyle.font.size - 6) + 'px','--hover': compontentStyle.hoverColor}">
							{{linkItem.text}}
						</el-menu-item>
					</el-submenu>
				</el-menu>
			</div>
			<div>
				<el-menu background-color="#f5f5f5" style="border:solid 0px #e1e1e1;" class="el-menu-vertical-demo"
					@open="handleOpen" @close="handleClose">
					<el-submenu :key="'link3'" :index="'link3'" :unique-opened="false"
						style="border-bottom:solid 1px #e1e1e1;">
						<template slot="title">
							<span :style="{fontSize:(selectdItem.preStyle.font.size - 4) + 'px'}"
								style="color: #000000 ;" slot="title">{{footerData.content.link3.name}}</span>
						</template>
						<el-menu-item class="linktit" :key="linkIndex" :index="'link3' + '-' + linkIndex"
							v-for="(linkItem,linkIndex) in footerData.content.link3.links"
							@click.stop.prevent="headNavTo(linkItem)"
							style="color: #8f8f8f;cursor: pointer;margin-top: 12px;"
							:style="{fontSize:(selectdItem.preStyle.font.size - 6) + 'px','--hover': compontentStyle.hoverColor}">
							{{linkItem.text}}
						</el-menu-item>
					</el-submenu>
				</el-menu>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getDesignfooter
	} from '../../api/footer.js'
	export default {
		props: {
			type: {
				type: String,
				default: "design"
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		watch: {
			// selectdItem: {
			// 	deep: true,
			// 	handler: async function(newV, oldV) {
			// 		if (this.type != 'build') {
			// 		} else {
			// 			console.log('this.footerDatathis.selectdItem', newV)
			// 			if(newV.compontChildren[0].data.footerData) {
			// 				this.footerData = newV.compontChildren[0].data.footerData
			// 				this.show = true
			// 				console.log('this.footerData', this.footerData)
			// 			}
						
			// 		}
			// 	}
			// },
		},
		data() {
			return {
				loading: false,
				show: false,
				footerData: {}
			}
		},
		async mounted() {
			if (this.type != 'build') {
				this.loading = true
				let wsid = this.$cookies.get("wsid")
				let data = await getDesignfooter({
					wsid
				})
				this.show = true
				this.footerData = data.data.data
				this.loading = false
				console.log('footerData', this.footerData)
				console.log('selectdItem', this.selectdItem)
			} else {
				console.log('this.footerDatathis.selectdItem', this.selectdItem)
				console.log('this.footerDatathis.selectdItem',  this.selectdItem.compontChildren[0].data.footerData)
				if(this.selectdItem.compontChildren[0].data.footerData) {
					this.footerData = this.selectdItem.compontChildren[0].data.footerData
					this.show = true
					console.log('this.footerData', this.footerData)
					
				}
			}


		},
		methods: {
			handleOpen() {

			},
			handleClose() {

			},
			// headNavTo(e) {
			// 	console.log('headNavTo', e)
			// 	if (e.new_window) {
			// 		window.open(e.link, '_blank')
			// 	} else {
			// 		window.open(e.link, '_blank')
			// 	}
			// },
			getPathFromUrl(url) {
				const match = url.match(/^https?:\/\/[^/]+(\/[^?#]*)/);
				return match ? match[1] : '/';
			},
			headNavTo(e) {
				if (!e) {
					return
				}
				if (e.new_window) {
					window.open(e.link, '_blank')
				}
				console.log(e)
				console.log(window.location.host)
				const path = this.getPathFromUrl(e.link);
				if (this.type != 'build') {
					let arr = e.link.split(window.location.host)
					if (this.$route.path == arr[1]) {}
					if (this.$route.path == '/') {
						this.$router.push({
							path: arr[1],
						})
						this.show = false
						window.location.reload()
					} else {
						this.show = false
						this.$router.replace({
							path: arr[1],
							query: {
								nav: new Date().getTime()
							}
						})
					}
					// window.location.reload()
				} else {
					let arr = e.link.split(window.location.host)
					if (this.$route.path == arr[1]) {}
					if (this.$route.path == '/') {
						this.$router.push({
							path: arr[1],
						})
						this.show = false
						window.location.reload()
					} else {
						this.show = false
						this.$router.replace({
							path: arr[1],
							query: {
								nav: new Date().getTime()
							}
						})
					}
					// window.location.reload()
				}

				// if (e.new_window) {
				// 	window.open(e.link, '_blank')
				// } else {
				// 	window.open(e.link, '_self')
				// }
			},


			navTo(e) {
				if (e.link.new_window) {
					window.open(e.link.link, '_blank')
				} else {
					window.open(e.link.link, '_blank')
				}
			},
		}

	}
</script>

<style scoped>
	.linktit:hover {
		cursor: pointer;
		color: '#ffee6a ';
	}
</style>